export default "__VITE_ASSET__D86Tm8Gw__"